import { useEffect } from 'react';
import { Brain, ChevronRight, X } from 'lucide-react';
import type { KnowledgeBase } from './types';

interface KbPickerModalProps {
  knowledgeBases: KnowledgeBase[];
  onSelect: (kbId: string) => void;
  onClose: () => void;
}

export function KbPickerModal({ knowledgeBases, onSelect, onClose }: KbPickerModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-surface-raised rounded-xl border border-border w-full max-w-md p-6 shadow-2xl">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-text-primary">Wybierz bazę wiedzy</h3>
          <button onClick={onClose} className="p-1 text-text-secondary hover:text-text-primary rounded-lg hover:bg-surface-hover transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-xs text-text-muted mb-4">
          Wybierz, na podstawie której bazy wiedzy chcesz wygenerować treść.
        </p>
        <div className="space-y-2">
          {knowledgeBases.filter(kb => kb.isComplete).map(kb => (
            <button
              key={kb.id}
              onClick={() => onSelect(kb.id)}
              className="w-full flex items-center gap-3 p-3 bg-surface-hover rounded-lg border border-border hover:border-accent-primary/30 hover:bg-surface-hover/80 transition-all text-left"
            >
              <Brain className="w-5 h-5 text-accent-primary shrink-0" />
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-text-primary truncate">{kb.name}</div>
                <div className="text-[11px] text-text-muted">Gotowa</div>
              </div>
              <ChevronRight className="w-4 h-4 text-text-disabled" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
